/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react';
import api from '../../services/api';
import moment from 'moment'

import 'moment/locale/pt';
import FixedContainer from '../../components/Container';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import { enqueueSnackbar } from 'notistack';

const RelatorioDiario = () => {
  const [date, setDate] = useState(null);
  const [loading_csv, setLoadingCsv] = useState(false);
  const [csv_link, setCsvLink] = useState("");

  const formatDate = (date) => {
    return moment.utc(new Date(date)).format('YYYY/MM/DD')
  }

  /** Get the download url from AWS */
  const getDownloadUrl = async () => {
    setLoadingCsv(true);
    try {

      const response = await api.post('/financial/createDailyReportAws', { date: formatDate(date !== null ? date : new Date()) });
      if (response === undefined) {
        enqueueSnackbar('Não houve retorno de dados para a requisição.', { variant: 'error' });
        return null;
      }
      setCsvLink(response.data.url);
      setLoadingCsv(false);
      enqueueSnackbar('Arquivo CSV gerado.', { variant: 'success' });
    } catch (error) {
      enqueueSnackbar('Ocorreu um erro na requisição.', { variant: 'error' });
    }
  }

  const downloadButton = async () => {
    try{
      window.location.href = csv_link;
    } catch(error) { console.log(error);}
  }

  return (
    <FixedContainer>
      <Box sx={{
        width: '100%',
        height: '100%',
        backgroundColor: '#F9FBFD',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        boxShadow: 3,
        borderRadius: '10px',
        padding: 2,
      }}>
        <Typography variant='h6' sx={{ fontWeight: 700, fontSize: '18px', paddingBottom: 1 }}>
          Procurar relatório por data
        </Typography>

        <Box sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}>

          <DatePicker
            sx={{margin: '10px 0', width: '25%'}}
            label="Data inicial"
            value={date}
            format="DD/MM/YYYY"
            onChange={(newValue) => setDate(newValue)}
          />

          <Box sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}>
            <Button
              variant='contained'
              style={{ marginLeft: '1em' }}
              color="success"
              disabled={!date || loading_csv}
              onClick={() => getDownloadUrl()}
            >
              Gerar CSV {loading_csv ? <CircularProgress sx={{marginLeft: 1}} size={20} color='inherit'/> : ''}
            </Button>

            <Button
              variant='contained'
              style={{ marginLeft: "1em" }}
              color="success"
              disabled={(csv_link === "")}
              onClick={() => downloadButton()}
            >
              Download CSV
            </Button>
          </Box>

        </Box>
      </Box>
    </FixedContainer>
  );

}

export default RelatorioDiario;
